import Basic from './basic.vue';
import MobBasic from './mob-basic.vue';

// 兆科眼科
export const componentMap = {
	basic: Basic,
	'mob-basic': MobBasic
};
